import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaAlert from './VaAlert.vue'

export default withConfigTransport(VaAlert)
